import React from 'react';

/**
 * Renderea el boton para mostrar un modal
 */
const ModalDispatcher = ({class_name, button_text, handleClickFunction}) => {
  return  <button className={class_name} type='button' data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={handleClickFunction}>{button_text}</button>
}

export default ModalDispatcher;